import { hasVisibleHtmlContent } from '../../../util/hasVisibleHtmlContent';
import { Card, CardBody, CardHeader } from '../../Card';
import { HTML } from '../../Html';
import { ExternalLink } from '../../Link';
import { Title } from '../../Title';
import type { SidebarCompanyDescriptionsProps } from './SidebarCompanyDescriptions.types';

export const SidebarCompanyDescriptions = ({ companyDescriptions, ...otherProps }: SidebarCompanyDescriptionsProps) => {
  if (!companyDescriptions || companyDescriptions.length === 0) {
    return null;
  }

  const nonEmptyDescriptions = companyDescriptions.filter(
    (desc) => desc.title?.trim() || hasVisibleHtmlContent(desc.description),
  );

  if (nonEmptyDescriptions.length === 0) {
    return null;
  }

  return nonEmptyDescriptions.map((companyDescription) => (
    // The filter above guarantees at least one of title/description is non-empty
    <Card key={companyDescription.title || companyDescription.description} {...otherProps}>
      {companyDescription.title?.trim() && (
        <CardHeader variant="panel">
          <Title>
            {companyDescription.clickUrl ? (
              <ExternalLink
                href={companyDescription.clickUrl}
                target="_blank"
                rel="noopener noreferrer"
                css={{ textDecoration: 'underline' }}
              >
                {companyDescription.title}
              </ExternalLink>
            ) : (
              companyDescription.title
            )}
          </Title>
        </CardHeader>
      )}
      {hasVisibleHtmlContent(companyDescription.description) && (
        <CardBody>
          <HTML html={companyDescription.description} />
        </CardBody>
      )}
    </Card>
  ));
};
